// extracted by mini-css-extract-plugin
export default {"wrapper":"UnsavedChangesModal_wrapper__x3CgE"};